import { Component, Fragment, h, Prop, State } from '@stencil/core';
import { unserialize } from '../../../utils';
import { ListItem } from './list-type';

export interface List {
    items?: ListItem[];
    columns?: number;
}

@Component({
    tag: 'web-list',
    shadow: false
})
export class WebList {
    @Prop() items: string;
    @Prop() columns: number = 1;

    @State() listItems: ListItem[] = [];

    componentWillLoad() {
        this.listItems = this.items ? (unserialize(this.items) as ListItem[]) : [];
    }

    render() {
        const { listItems, columns } = this;
        return (
            <ul class="web-list" style={{ '--web-list-columns': `${columns}` }}>
                {listItems.map(this.renderListItem)}
            </ul>
        );
    }

    private renderListItem = (item: ListItem) => {
        const { type, text, rel, target, url, menuName } = item;
        switch (type) {
            case 'menuLink':
                return (
                    <li role="presentation">
                        <a
                            id={menuName + '-trigger'}
                            role="menuitem"
                            class="simple"
                            href="#"
                            title={text}
                            aria-haspopup="true"
                            aria-controls={menuName}
                            data-menu-link={menuName}
                        >
                            {this.renderItem(item)}
                        </a>
                    </li>
                );
            case 'link':
            case 'text':
            default:
                // TODO: use cases correctly when data has correct type values
                return url ? (
                    <li>
                        <a class="simple" href={url} title={text} rel={rel} target={target} {...item.customAttributes}>
                            {this.renderItem(item)}
                        </a>
                    </li>
                ) : (
                    <li>{this.renderItem(item)}</li>
                );
        }
    };

    private renderItem = ({ iconStart, iconEnd, text }: ListItem) => (
        <Fragment>
            {iconStart && <web-icon class="icon-start" name={iconStart.name}></web-icon>}
            {text}
            {iconEnd && <web-icon class="icon-end" name={iconEnd.name}></web-icon>}
        </Fragment>
    );
}
